import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M10 3a.7.7 0 0 1 .633.4l1.811 3.822 3.948.522a.7.7 0 0 1 .422 1.168l-2.833 3.069.782 4.19a.7.7 0 0 1-1.003.754L10 15.035l-3.76 1.89a.7.7 0 0 1-1.003-.753l.782-4.191-2.833-3.069a.7.7 0 0 1 .422-1.168l3.948-.522L9.367 3.4A.7.7 0 0 1 10 3Zm0 2.334L8.658 8.166a.7.7 0 0 1-.541.394l-2.987.395 2.156 2.334a.7.7 0 0 1 .174.603l-.588 3.148 2.813-1.415a.7.7 0 0 1 .63 0l2.813 1.415-.588-3.148a.7.7 0 0 1 .174-.603l2.156-2.334-2.987-.395a.7.7 0 0 1-.54-.394L10 5.334Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
